import { SceneNode } from '@/features/screenplay/components/editor/nodes/SceneNode'
import { extractScenesFromContent } from '@/features/screenplay/utils/sceneUtils'
import { db } from '@/shared/lib/db'
import { toastService } from '@/shared/services/toast.service'
import { $getRoot, LexicalEditor } from 'lexical'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface SceneState {
    scenes: SceneNode[]
    isLoading: boolean
    loadedProjectId: string | null,
    editor: LexicalEditor | null,
    setEditor: (editor: LexicalEditor) => void,
    setScenes: (scenes: SceneNode[]) => void
    loadScenes: (projectId: string) => Promise<void>
}

export const useSceneStore = create<SceneState>()(
    devtools((set) => ({
        scenes: [],
        isLoading: false,
        loadedProjectId: null,
        editor: null,
        setEditor: (editor) => {
            set({ editor: editor })
            editor.read(() => {
                const sceneNodes = $getRoot().getChildren().filter((node) => node instanceof SceneNode)
                set({ scenes: sceneNodes })
            })
        },
        setScenes: (scenes) => set({ scenes }),
        loadScenes: async (projectId) => {
            set({ isLoading: true })
            try {
                // Fetch the first screenplay for the project
                const screenplay = await db.screenplays
                    .where('projectId')
                    .equals(projectId)
                    .first()

                if (screenplay && screenplay.content) {
                    const scenes = extractScenesFromContent(screenplay.content)
                    //TODO: set scenes to scene store
                    // set({ scenes, loadedProjectId: projectId })
                } else {
                    set({ scenes: [], loadedProjectId: projectId })
                }
            } catch (error) {
                toastService.error('Failed to load scenes')
            } finally {
                set({ isLoading: false })
            }
        },
    }))
)
